module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal-fade"
    }
  }, [(_vm.modal_active) ? _c('div', {
    staticClass: "info_modal"
  }, [_c('svg', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "viewBox": "0 0 1280 720"
    }
  }, [_c('g', [_c('rect', {
    attrs: {
      "id": "screen_background",
      "stroke": "#FFFFFF",
      "stroke-width": "5",
      "fill-opacity": "0",
      "fill": "#7BADD6",
      "x": "60",
      "y": "60",
      "width": "1161",
      "height": "600",
      "rx": "10"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "left_background",
      "fill": "#7BADD6",
      "opacity": "0.95",
      "x": "62",
      "y": "62",
      "width": "1157",
      "height": "596",
      "rx": "10"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal-fade"
    }
  }, [_c('g', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected_answer === ''),
      expression: "selected_answer === ''"
    }]
  }, [_c('transition', {
    attrs: {
      "name": "modal-fade"
    }
  }, [_c('g', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quiz_question < 1),
      expression: "quiz_question < 1"
    }]
  }, [_c('g', {
    attrs: {
      "id": "quiz_instructions_container",
      "transform": "translate(230.000000, 289.000000)"
    }
  }, [_c('text', {
    attrs: {
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "24",
      "font-weight": "normal",
      "text-align": "center",
      "fill": "#FFFFFF"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "-50.64209",
      "y": "-50.2890625"
    }
  }, [_vm._v("Just as Aye struggled to interpret the situation between the couple in the library, it")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-50.64209",
      "y": "-14.2890625"
    }
  }, [_vm._v("can be hard to interpret and assess the health of a relationship right away. As a")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-50.64209",
      "y": "22.2890625"
    }
  }, [_vm._v("class, take a few minutes to read the following scenarios and decide if they depict")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-50.64209",
      "y": "58.2890625"
    }
  }, [_vm._v("a healthy relationship or if there are red flags that indicate an unhealthy or abusive")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-50.64209",
      "y": "94.2890625"
    }
  }, [_vm._v("situation.")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-50.64209",
      "y": "130.2890625"
    }
  }), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-50.64209",
      "y": "166.2890625"
    }
  }), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-50.64209",
      "y": "202.2890625"
    }
  })])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "proceed_button",
      "transform": "translate(500.000000, 480.000000)"
    },
    on: {
      "click": _vm.toggle_quiz_question
    }
  }, [_c('rect', {
    attrs: {
      "fill": "#FFFFFF",
      "x": "-10",
      "y": "80",
      "width": "250",
      "height": "44",
      "rx": "22"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "16",
      "font-weight": "normal",
      "fill": "#4A90E2"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "15.4648438",
      "y": "108.7734375"
    }
  }, [_vm._v("Click To Test Your Instincts!")])])])])]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(250.000000, 183.000000)"
    }
  }, [_c('text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quiz_question == 1),
      expression: "quiz_question == 1"
    }],
    attrs: {
      "id": "quiz_question",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "22",
      "font-weight": "normal",
      "line-spacing": "30",
      "fill": "#FFFFFF"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "-65.64209",
      "y": "-15.2890625"
    }
  }, [_vm._v("Scott and Emily have been dating for the past three weeks. Since they started dating,")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-65.64209",
      "y": "21.2890625"
    }
  }, [_vm._v("they’ve been having a ton of fun. They have spent every moment they can with one another,")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-65.64209",
      "y": "57.2890625"
    }
  }, [_vm._v("and when they are not together, they text or video chat continually. Most nights they fall")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-65.64209",
      "y": "93.2890625"
    }
  }, [_vm._v("asleep with video chat still on. Emily woke up a few days ago to see that their chat had")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-65.64209",
      "y": "129.2890625"
    }
  }, [_vm._v("been going for 10 hours! What do you think? Is Emily and Scott’s relationship healthy, or are")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-65.64209",
      "y": "165.2890625"
    }
  }, [_vm._v("there red flags?")])]), _vm._v(" "), _c('text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quiz_question == 2),
      expression: "quiz_question == 2"
    }],
    attrs: {
      "id": "quiz_question",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "22",
      "font-weight": "normal",
      "line-spacing": "30",
      "fill": "#FFFFFF"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "-50.2890625"
    }
  }, [_vm._v("Aretha and Anthony met each other while Anthony was dating someone else They only hung out a")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "-10.2890625"
    }
  }, [_vm._v("few times before he broke up with his girlfriend, but the reality is that he cheated. In the beginning")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "30.2890625"
    }
  }, [_vm._v(" of their relationship, everything seemed perfect. Then school and basketball season got crazy,")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "70.2890625"
    }
  }, [_vm._v("and Aretha has been feeling nervous lately. They are apart more than they’re together, and she")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "110.2890625"
    }
  }, [_vm._v("worries that he will meet someone new. Aretha has started asking Anthony to text and send photos")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "150.2890625"
    }
  }, [_vm._v("at certain times of day, so she can see where he is and who he is with. When he doesn’t respond")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "190.2890625"
    }
  }, [_vm._v("right away, Aretha texts and calls more. Is Aretha and Anthony’s relationship healthy, or are there")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "230.2890625"
    }
  }, [_vm._v("red flags?")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "270.2890625"
    }
  }), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "320.2890625"
    }
  })]), _vm._v(" "), _c('text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quiz_question == 3),
      expression: "quiz_question == 3"
    }],
    attrs: {
      "id": "quiz_question",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "22",
      "font-weight": "normal",
      "line-spacing": "30",
      "fill": "#FFFFFF"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "-50.2890625"
    }
  }, [_vm._v("Doug and Janelle have an intense relationship. When things are going well, they are going really")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "-10.2890625"
    }
  }, [_vm._v("well — and when things are going bad, they are really bad. Sometimes things even get physical.")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "30.2890625"
    }
  }, [_vm._v("Last week, Doug got so mad at Janelle that he posted nasty things about her on Facebook and an")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "70.2890625"
    }
  }, [_vm._v("explicit photo of her captioned “whore” on Snapchat. Janelle was embarrassed and had to")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "110.2890625"
    }
  }, [_vm._v("speak to the school resource officer because someone sent a screenshot of the photo to an")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "150.2890625"
    }
  }, [_vm._v("administrator. What do you think? Is Doug and Janelle’s relationship healthy, or are there red")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "190.2890625"
    }
  }, [_vm._v("flags?")])]), _vm._v(" "), _c('text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quiz_question == 4),
      expression: "quiz_question == 4"
    }],
    attrs: {
      "id": "quiz_question",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "22",
      "font-weight": "normal",
      "line-spacing": "30",
      "fill": "#FFFFFF"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "-50.2890625"
    }
  }, [_vm._v("Hannah and Rashid seem like an unlikely pair. When they met, Hannah wasn’t popular, while Rashid")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "-10.2890625"
    }
  }, [_vm._v("ruled the school. Hannah felt surprised and lucky that he was interested in her. At first, Rashid was")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "30.2890625"
    }
  }, [_vm._v("sweet, telling Hannah to be more confident because she was beautiful and smart. But after a while,")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "70.2890625"
    }
  }, [_vm._v("things began to change. When Hannah would make a mistake or do something Rashid found silly, he")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "110.2890625"
    }
  }, [_vm._v("would roll his eyes and say, “typical Hannah” or call her dumb. When he is especially annoyed with")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "150.2890625"
    }
  }, [_vm._v("her, he says she is lucky he dates her because no one else will put up with all the stupid things she")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "190.2890625"
    }
  }, [_vm._v("does. Is Hannah and Rashid’s relationship healthy, or are there red flags?")])]), _vm._v(" "), _c('text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quiz_question == 5),
      expression: "quiz_question == 5"
    }],
    attrs: {
      "id": "quiz_question",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "22",
      "font-weight": "normal",
      "line-spacing": "30",
      "fill": "#FFFFFF"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "-50.2890625"
    }
  }, [_vm._v("Matt and Michaela have been dating for 10 months. They started out as friends, and then one day")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "-10.2890625"
    }
  }, [_vm._v("Michaela confessed that she had a huge crush on Matt. They talked about what it would be like to")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "30.2890625"
    }
  }, [_vm._v("date, because they didn’t want to lose each other’s friendship. Now that they are together, they try")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "70.2890625"
    }
  }, [_vm._v("to go on dates with other couples but make sure they spend quality one-on-one time as well. At")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "110.2890625"
    }
  }, [_vm._v("times they drive each other crazy, but when those times happen they try their best to talk")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "150.2890625"
    }
  }, [_vm._v("through their issues. What do you think? Is Matt and Michaela’s relationship healthy, or are there")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-105.64209",
      "y": "190.2890625"
    }
  }, [_vm._v("red flags?")])])]), _vm._v(" "), _c('g', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quiz_question < 6 && _vm.quiz_question > 0),
      expression: "quiz_question < 6 && quiz_question > 0"
    }],
    attrs: {
      "transform": "translate(251.000000, 203.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "submit_button",
      "transform": "translate(685.000000, 275.000000)"
    },
    on: {
      "click": _vm.toggle_answer_explanation
    }
  }, [_c('rect', {
    attrs: {
      "fill": "#FFFFFF",
      "x": "-60",
      "y": "50",
      "width": "160",
      "height": "44",
      "rx": "22"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "16",
      "font-weight": "normal",
      "line-spacing": "16",
      "fill": "#4A90E2"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "-10.1111245",
      "y": "77.7734375"
    }
  }, [_vm._v("SUBMIT")])])]), _vm._v(" "), _c('g', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quiz_question < 6 && _vm.quiz_question > 0),
      expression: "quiz_question < 6 && quiz_question > 0"
    }],
    on: {
      "click": _vm.toggle_healthy_answer_color
    }
  }, [_c('g', {
    staticClass: "answer",
    attrs: {
      "id": "correct",
      "transform": "translate(0.000000, 290.000000)",
      "fill": "#FFFFFF"
    }
  }, [_c('text', {
    attrs: {
      "id": "healthy",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "24",
      "font-weight": "normal",
      "line-spacing": "30"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "-30",
      "y": "27.5"
    }
  }, [_vm._v("Healthy")])]), _vm._v(" "), _c('g', {
    class: _vm.healthy_selection_state,
    attrs: {
      "id": "selected_answer"
    }
  }, [_c('circle', {
    attrs: {
      "id": "answer_selection",
      "cx": "-60",
      "cy": "20",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "answer_fill",
    attrs: {
      "id": "health",
      "fill": "#599ED6",
      "cx": "-60",
      "cy": "20",
      "r": "7"
    }
  })])])]), _vm._v(" "), _c('g', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quiz_question < 6 && _vm.quiz_question > 0),
      expression: "quiz_question < 6 && quiz_question > 0"
    }],
    on: {
      "click": _vm.toggle_red_flag_answer_color
    }
  }, [_c('g', {
    staticClass: "answer",
    attrs: {
      "id": "wrong",
      "transform": "translate(0.000000, 110.000000)"
    }
  }, [_c('text', {
    attrs: {
      "id": "red_flag",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "24",
      "font-weight": "normal",
      "line-spacing": "30",
      "fill": "#FFFFFF"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "-30",
      "y": "280"
    }
  }, [_vm._v("Red Flag")])]), _vm._v(" "), _c('g', {
    class: _vm.red_flag_selection_state,
    attrs: {
      "id": "selected_answer"
    }
  }, [_c('circle', {
    attrs: {
      "id": "answer_selection",
      "fill": "#FFFFFF",
      "cx": "-60",
      "cy": "270",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "answer_fill",
    attrs: {
      "id": "red",
      "fill": "#599ED6",
      "cx": "-60",
      "cy": "270",
      "r": "7"
    }
  })])])])])], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal-fade"
    }
  }, [(_vm.selected_answer !== '') ? _c('g', {
    attrs: {
      "transform": "translate(251.000000, 203.000000)"
    }
  }, [_c('rect', {
    attrs: {
      "transform": "translate(-251.000000, -203.000000)",
      "id": "left_background",
      "fill": _vm.modalColor,
      "x": "62",
      "y": "62",
      "width": "1157",
      "height": "596",
      "rx": "10"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(0.000000, 80.000000)"
    }
  }, [(_vm.quiz_question === 1) ? _c('text', {
    attrs: {
      "id": "healthy_explanation",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "24",
      "font-weight": "normal",
      "line-spacing": "30",
      "fill": "#FFFFFF"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "-15.2890625"
    }
  }, [_vm._v("You may be right. The beginning of relationships can be naturally exciting and")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "21.2890625"
    }
  }, [_vm._v("consuming emotionally. You like each other so much that you want to spend all your")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "57.2890625"
    }
  }, [_vm._v("time together. Spending a lot of time with one another and communicating constantly")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "93.2890625"
    }
  }, [_vm._v("using digital technology doesn’t mean the relationship is unhealthy or abusive. Just")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "129.2890625"
    }
  }, [_vm._v("make sure that you begin to find a balance between your new relationship and the")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "165.2890625"
    }
  }, [_vm._v("rest of your life.")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "201.2890625"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.quiz_question === 2 && _vm.red_flag_selection_state === 'active') ? _c('text', {
    attrs: {
      "id": "red_flag_explanation",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "24",
      "font-weight": "normal",
      "line-spacing": "30",
      "fill": "#FFFFFF"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "-15.2890625"
    }
  }, [_vm._v("You are correct. The dynamic that Aretha is setting up in their relationship is one of")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "21.2890625"
    }
  }, [_vm._v("power and control. Aretha’s constant check-ins and blow-ups make it impossible for")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "57.2890625"
    }
  }, [_vm._v("Anthony to keep her happy. When Aretha becomes unhappy, she becomes")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "93.2890625"
    }
  }, [_vm._v("emotionally and psychologically abusive to Anthony.")])]) : (_vm.quiz_question === 2) ? _c('text', {
    attrs: {
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "24",
      "font-weight": "normal",
      "line-spacing": "30",
      "fill": "#FFFFFF"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "-15.2890625"
    }
  }, [_vm._v("While at first you may think Aretha is only trying to show Anthony how much she")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "21.2890625"
    }
  }, [_vm._v("cares about him, in reality, Aretha is using modes of power and control over")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "57.2890625"
    }
  }, [_vm._v("Anthony. Anthony may be feeling like he is walking on eggshells to keep Aretha")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "93.2890625"
    }
  }, [_vm._v("happy. Aretha’s jealousy is impacting Anthony’s ability to maintain his normal life.")])]) : _vm._e(), _vm._v(" "), (_vm.quiz_question === 3 && _vm.red_flag_selection_state === 'active') ? _c('text', {
    attrs: {
      "id": "healthy_explanation",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "24",
      "font-weight": "normal",
      "line-spacing": "30",
      "fill": "#FFFFFF"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "-15.2890625"
    }
  }, [_vm._v("You are correct. Doug and Janelle’s relationship is full of red flags. Healthy relationships")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "21.2890625"
    }
  }, [_vm._v("do not feel like a rollercoaster. They of course have their ups and downs, but mutually")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "57.2890625"
    }
  }, [_vm._v("respectful partners know what to expect from one another. Healthy relationships are")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "93.2890625"
    }
  }, [_vm._v("also not physically abusive, and exploiting a partner on social media is NEVER okay.")])]) : (_vm.quiz_question === 3) ? _c('text', {
    attrs: {
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "24",
      "font-weight": "normal",
      "line-spacing": "30",
      "fill": "#FFFFFF"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "-15.2890625"
    }
  }, [_vm._v("You are incorrect. Doug and Janelle’s relationship is actually full of red flags. Healthy")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "21.2890625"
    }
  }, [_vm._v("relationships do not feel like a rollercoaster. They of course have their ups and downs,")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "57.2890625"
    }
  }, [_vm._v("but mutually respectful partners know what to expect from one another. Healthy")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "93.2890625"
    }
  }, [_vm._v("relationships are also not physically abusive, and exploiting a partner on social media")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "129.2890625"
    }
  }, [_vm._v("is NEVER okay.")])]) : _vm._e(), _vm._v(" "), (_vm.quiz_question === 4 && _vm.red_flag_selection_state === 'active') ? _c('text', {
    attrs: {
      "id": "healthy_explanation",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "24",
      "font-weight": "normal",
      "line-spacing": "30",
      "fill": "#FFFFFF"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "-15.2890625"
    }
  }, [_vm._v("You are correct. When someone constantly puts down their partner, it can cause their")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "21.2890625"
    }
  }, [_vm._v("partner’s self worth to drop drastically. A healthy relationship is focused on uplifting")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "57.2890625"
    }
  }, [_vm._v("a partner, not bringing them down. Many victims stay in an abusive relationship")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "93.2890625"
    }
  }, [_vm._v("longer because their abuser has convinced them that no one else would love them,")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-75.64209",
      "y": "129.2890625"
    }
  }, [_vm._v("and they are the kind one for staying with them.")])]) : (_vm.quiz_question === 4) ? _c('text', {
    attrs: {
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "24",
      "font-weight": "normal",
      "line-spacing": "30",
      "fill": "#FFFFFF"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "-90.64209",
      "y": "-15.2890625"
    }
  }, [_vm._v("You are incorrect. When someone constantly puts down their partner it can cause their")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-90.64209",
      "y": "21.2890625"
    }
  }, [_vm._v("partner’s self worth to drop drastically. A healthy relationship is focused on uplifting a")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-90.64209",
      "y": "57.2890625"
    }
  }, [_vm._v("partner, not bringing them down. Many victims stay in an abusive relationship longer")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-90.64209",
      "y": "93.2890625"
    }
  }, [_vm._v("because their abuser has convinced them that no one else would love them and they")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-90.64209",
      "y": "129.2890625"
    }
  }, [_vm._v("are the kind one for staying with them.")])]) : _vm._e(), _vm._v(" "), (_vm.quiz_question === 5 && _vm.healthy_selection_state === 'active') ? _c('text', {
    attrs: {
      "id": "healthy_explanation",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "24",
      "font-weight": "normal",
      "line-spacing": "30",
      "fill": "#FFFFFF"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "-95.64209",
      "y": "-15.2890625"
    }
  }, [_vm._v("You are correct. Matt and Michaela seem to be enjoying each other and their relationship.")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-95.64209",
      "y": "21.2890625"
    }
  }, [_vm._v("Sure, everything might not always be perfect, but by focusing on communication and")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-95.64209",
      "y": "57.2890625"
    }
  }, [_vm._v("mutual respect, their relationship is on the right track. It might not last forever, but for")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-95.64209",
      "y": "93.2890625"
    }
  }, [_vm._v("now it is a healthy relationship.")])]) : (_vm.quiz_question === 5) ? _c('text', {
    attrs: {
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "24",
      "font-weight": "normal",
      "line-spacing": "30",
      "fill": "#FFFFFF"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "-95.64209",
      "y": "-15.2890625"
    }
  }, [_vm._v("You are incorrect. Matt and Michaela seem to be enjoying each other and their relationship.")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-95.64209",
      "y": "21.2890625"
    }
  }, [_vm._v("Sure, everything might not always be perfect but by focusing on communication and")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-95.64209",
      "y": "57.2890625"
    }
  }, [_vm._v("mutual respect, their relationship is on the right track. Just because a couple fights doesn’t")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-95.64209",
      "y": "93.2890625"
    }
  }, [_vm._v("mean the relationship is abusive. Matt and Michaela’s relationship might not last forever,")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-95.64209",
      "y": "129.2890625"
    }
  }, [_vm._v("but for now it is a healthy relationship.")])]) : _vm._e()]), _vm._v(" "), (_vm.healthy_selection_state === 'active') ? _c('text', {
    attrs: {
      "id": "healthy_flag_explanation",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "24",
      "font-weight": "normal",
      "line-spacing": "30",
      "fill": "#FFFFFF"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "340.994629",
      "y": "17.5"
    }
  }, [_vm._v("Healthy")])]) : _vm._e(), _vm._v(" "), (_vm.red_flag_selection_state === 'active') ? _c('text', {
    attrs: {
      "id": "red_flag_explanation",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "24",
      "font-weight": "normal",
      "line-spacing": "30",
      "fill": "#FFFFFF"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "340.994629",
      "y": "17.5"
    }
  }, [_vm._v("Red Flag")])]) : _vm._e(), _vm._v(" "), _c('text', {
    attrs: {
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "50",
      "font-weight": "normal",
      "line-spacing": "50",
      "fill": "#FFFFFF"
    }
  }, [(!_vm.isCorrect) ? _c('tspan', {
    attrs: {
      "x": "238.994629",
      "y": "-25.2890625"
    }
  }, [_vm._v("NOT QUITE.")]) : _vm._e(), _vm._v(" "), (_vm.isCorrect) ? _c('tspan', {
    attrs: {
      "x": "268.994629",
      "y": "-25.2890625"
    }
  }, [_vm._v("CORRECT!")]) : _vm._e()]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "proceed_button",
      "transform": "translate(611.000000, 310.000000)"
    },
    on: {
      "click": _vm.toggle_quiz_question
    }
  }, [_c('rect', {
    attrs: {
      "fill": "#FFFFFF",
      "x": "0",
      "y": "40",
      "width": "155",
      "height": "44",
      "rx": "22"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "16",
      "font-weight": "normal",
      "line-spacing": "16",
      "fill": "#707070"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "42.2361245",
      "y": "67.7734375"
    }
  }, [_vm._v("PROCEED")])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal-fade"
    }
  }, [_c('g', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quiz_question > 5),
      expression: "quiz_question > 5"
    }]
  }, [_c('g', {
    attrs: {
      "id": "class_instructions_container",
      "transform": "translate(230.000000, 300.000000)"
    }
  }, [_c('text', {
    attrs: {
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "26",
      "font-weight": "normal",
      "text-align": "center",
      "line-spacing": "20",
      "fill": "#FFFFFF"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "-50.64209",
      "y": "-50.2890625"
    }
  }, [_vm._v("In order to Take a Stand FOR Healthy Relationships, it is important to be able")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-50.64209",
      "y": "-14.2890625"
    }
  }, [_vm._v("to identify components of an unhealthy or abusive relationship. Your teacher")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-50.64209",
      "y": "22.2890625"
    }
  }, [_vm._v("has a few lessons to practice this skill so that you too can Take a Stand FOR")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "-50.64209",
      "y": "58.2890625"
    }
  }, [_vm._v("Healthy Relationships.")])])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "proceed_button",
      "transform": "translate(500.000000, 480.000000)"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('rect', {
    attrs: {
      "fill": "#FFFFFF",
      "x": "50",
      "y": "80",
      "width": "155",
      "height": "44",
      "rx": "22"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "16",
      "font-weight": "normal",
      "line-spacing": "16",
      "fill": "#4A90E2"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "90.4648438",
      "y": "108.7734375"
    }
  }, [_vm._v("PROCEED")])])])])])], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-661bb7b4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_4/quiz.vue
// module id = 777
// module chunks = 1